<template>
    <div></div>
</template>

<script>
export default {
    props: {
        datalayerEventData: { required: true },
    },
    created() {
        document.addEventListener('DOMContentLoaded', event => {
            for (const key in this.datalayerEventData) {
                dataLayer.push(this.datalayerEventData[key]);
            }
            window.productListDatalayerEventData = this.datalayerEventData;
        });

        this.$root.$on('datalayerViewCategoryEvent', datalayerEventData => {
            for (const key in datalayerEventData) {
                dataLayer.push(datalayerEventData[key]);
            }
            window.productListDatalayerEventData = datalayerEventData;
        });
    },
};
</script>
